import { ColumnHeader, Divider, Loading, ProgressBar, Table, TableColumn, TableRow, Tooltip } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import ParseHtml from 'html-react-parser';
import styled from 'styled-components';
import { ClearDiv, LoadingWrapper, NoSearchResultsMessage } from '../../../components/common';
import { BodyCopyMedium, LabelMedium } from '../../../components/common/styles/globalStyles';
import ContentConstants from '../../../contentConstants';
import { IColumn } from '../../../models';
import { ITrendSurvey } from '../../../models/ITrendSurvey';
import { ColumnHelper } from '../../../utilities';

export const TooltipContent = (): JSX.Element => (
	<div>
		<strong>{ContentConstants.TREND_SURVEYS_TOOL_TIP_TITLE}</strong>
		<p>{ContentConstants.TREND_SURVEYS_TOOL_TIP}</p>
	</div>
);

export interface ITrendSurveysProps {
	trendSurveys: ITrendSurvey[];
	trendGroupName: string;
	loading: boolean;
}

export const BoldProgressBar = styled(ProgressBar).attrs<{}>({
	className: 'tws-bold-progress',
})`
	&.tws-bold-progress {
		font-weight: bold;
	}
`;

export class TrendSurveys extends React.Component<ITrendSurveysProps> {
	private columns: IColumn[] = [
		{
			name: 'name',
			displayText: ContentConstants.TABLE_HEADER_REPORTING_SURVEYNAME,
			checked: true,
			displayOrder: 1,
			disabled: false,
		},
		{
			name: 'matchingQuestions',
			displayText: ContentConstants.TABLE_HEADER_REPORTING_MATCHINGQUESTIONS,
			checked: true,
			displayOrder: 2,
			disabled: false,
		},
		{
			name: 'matchingDimensions',
			displayText: ContentConstants.TABLE_HEADER_REPORTING_MATCHINGDIMENSIONS,
			checked: true,
			displayOrder: 3,
			disabled: false,
		},
	];

	constructor(props: ITrendSurveysProps) {
		super(props);
	}

	public render() {
		const { trendSurveys, trendGroupName, loading } = this.props;

		const instructions = ContentConstants.REPORTING_TRENDS_PREVIOUS_SURVEYS_INSTRUCTIONS;
		const note = ContentConstants.REPORTING_TRENDS_PREVIOUS_SURVEYS_NOTE;
		const sectionText = `${instructions.replace('{trendGroupName}', trendGroupName)} ${note} `;
		return (
			<>
				<LabelMedium>{ContentConstants.REPORTING_TRENDS_PREVIOUS_SURVEYS_LABEL}</LabelMedium>
				<BodyCopyMedium>
					{ParseHtml(sectionText)} <Tooltip id={'1'}>{TooltipContent()}</Tooltip>
				</BodyCopyMedium>
				<ClearDiv clearHeight='10px' clearHeightMobile='10px' />
				<Divider type='dashed' />
				{loading && (
					<LoadingWrapper>
						<Loading height={'70px'} width={'70px'} />
					</LoadingWrapper>
				)}
				{!loading && trendSurveys.length > 0 && (
					<Table responsive={true}>
						<ColumnHeader columns={ColumnHelper.GetColumnHeaders(this.columns)} />
						<tbody>
							{trendSurveys.map((survey: ITrendSurvey, index) => (
								<TableRow key={index} record={survey.surveyId}>
									<TableColumn>{survey.surveyName}</TableColumn>
									<TableColumn>
										<BoldProgressBar
											type='bartext'
											bgcolor='#5C2E8D'
											color='#000000'
											value={survey.matchingQuestionsPercent}
											max='100'
											height='20px'
											fontSize='12.5px'
										/>
									</TableColumn>
									<TableColumn>
										{survey.matchingDimensions} {ContentConstants.OF} {survey.totalDimensions}
									</TableColumn>
								</TableRow>
							))}
						</tbody>
					</Table>
				)}
				{!loading && trendSurveys.length === 0 && (
					<NoSearchResultsMessage message={ContentConstants.REPORTING_NO_TREND_SURVEYS} textAlign={'left'} />
				)}
			</>
		);
	}
}
